// Device detection utilities for mobile optimization
export const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || navigator.maxTouchPoints > 0);

export const isMobile = () =>
  isTouchDevice() || (typeof window !== 'undefined' && window.innerWidth <= 768);

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
